<script>
    import {mapState, mapActions, mapGetters} from 'vuex'

    export default {
        props: {},
        data() {
            return {}
        },
        methods: {},
        computed: {
            ...mapState('user/style',{
                footer: 'footer'
            }),
            ...mapState('user', {
                auth: 'auth',
            }),
        },
        watch: {},
        components: {},
        mounted() {

        },
        destroyed() {

        },
    }
</script>
<template>
    <div class="mag-footer">
        <template v-if="footer.text">
            {{footer.text}} <br>
        </template>
        {{'© 2011-' + new Date().getFullYear() + ' MAG.travel Проект Master-Agent. Все права защищены. +7 (495) 6-020-020, info@mag.travel'}}
    </div>
</template>
<style lang="scss">
    .login{
        .mag-footer{
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 8px 36px 0 36px;
            overflow: hidden;
            height: 60px;
            width: 100%;
            background: #778ea8 url(./img/foot_bg.png) bottom no-repeat;
            text-align: center;
            font-size: 15px;
            font-weight: 300;
            color: #bac6d3;
            text-align: center;
        }
    }
</style>
